import React from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { viewRangeSelector } from 'common/selectors';
import { RESPONSIVE_RANGES } from 'utils/enums';
import { MobileCollectionDecorted } from 'components/video-collection/mobile';
import { DesktopCollectionDecorated } from 'components/video-collection/desktop';

const Component = (props) => {
  const isMobile =
    props.viewRange === RESPONSIVE_RANGES.MOBILE_SMALL || props.viewRange === RESPONSIVE_RANGES.MOBILE_LARGE;
  if (isMobile) {
    return (
      <MobileCollectionDecorted
        baseUrl={props.baseUrl}
        withSort={props.withSort}
        sortBy={props.sortBy}
        loadCollectionAction={props.loadCollectionAction}
        loadMoreAction={props.loadMoreAction}
      >
        {props.children}
      </MobileCollectionDecorted>
    );
  } else {
    return (
      <DesktopCollectionDecorated
        baseUrl={props.baseUrl}
        withSort={props.withSort}
        sortBy={props.sortBy}
        loadCollectionAction={props.loadCollectionAction}
      >
        {props.children}
      </DesktopCollectionDecorated>
    );
  }
};

export const VideoCollection = connect(
  (state) => ({
    viewRange: viewRangeSelector(state),
  }),
  false
)((props) => <Component {...props} />);

VideoCollection.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  loadCollectionAction: PropTypes.object.isRequired,
  loadMoreAction: PropTypes.object.isRequired,
  withSort: PropTypes.bool,
  sortBy: PropTypes.array.isRequired,
};
